import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LOCAL_STORAGE_ITEMS } from '../constants'; // 根据实际目录修改路径

const TOKEN_KEY = LOCAL_STORAGE_ITEMS.token;

const SIGN_IN_PATH = '/authentication';

const PUBLIC_PATHS = [
    SIGN_IN_PATH,
];

export default function AuthSyncListener() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const isPublicPage = PUBLIC_PATHS.some(
            (path) =>
                location.pathname === path ||
                location.pathname.startsWith(`${path}/`)
        );

        const redirectToSignIn = () => {
            if (!isPublicPage) {
                navigate(SIGN_IN_PATH, { replace: true });
            }
        };

        const handleStorageChange = (event) => {
            if (
                event.key === TOKEN_KEY &&
                event.oldValue !== null &&
                event.newValue === null
            ) {
                redirectToSignIn();
            }
        };

        window.addEventListener('storage', handleStorageChange);

        // 刷新受保护页面时检查 token 是否存在
        if (!isPublicPage && !localStorage.getItem(TOKEN_KEY)) {
            redirectToSignIn();
        }

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [location.pathname, navigate]);

    return null;
}